export const events = {
  visitReferralProgramPage: 'Visist referral page',
  copyReferralProgramLink: 'Copies referral page link',
  visitReferralProgramLink: 'Visist referral page link',
  dimissSettingsReferralBanner: 'Dismiss settings referral banner',
  clickSettingsReferralBanner: 'Click settings referral banner',
  clickDropdownReferFactorial: 'Click dropdown refer factorial',
  openReferralProgramRewardModal: 'Open referral program reward modal',
  clickGenerateReferralProgramLink: 'Click generate referral program link',
  clickResetReferralProgramLink: 'Click reset referral program link',
  visitDetail: 'Visits settings detail',
  viewHomepage: 'View settings homepage',
  goToDetail: 'Go to settings detail',
  backPage: 'Go to previous page',
  searchEmpty: 'Search setting Empty',
  searchSubmit: 'Search setting submit',
  searchStart: 'Search setting start',
  searchSuccess: 'Search setting Success',
}
